/**
 * 枚举类
 */
export class Enum {
    /**
     * 添加枚举字段
     * field: 枚举字段
     * label: 界面显示 name
     * value: 枚举值 id
     */
    add (id,  name, field) {
        this[field] = {id, name};
        return this
    }

    add (id,  name, field, desc) {
        this[field] = {id, name, desc};
        return this
    }

    /**
     * 根据枚举id获取其name
     */
    getIdByName (name) {
        // 字段不存在返回‘’
        if (name === undefined || name === null) {
            return ''
        }
        for (let i in this) {
            let e = this[i];
            if (e && e.name === name) {
                return e.id
            }
        }

        return ''
    }

    getNameById (id) {
        // 字段不存在返回‘’
        if (id === undefined || id === null) {
            return ''
        }
        for (let i in this) {
            let e = this[i];
            if (e && e.id === id) {
                return e.name
            }
        }

        return ''
    }


    /**
     * 根据枚举id获取其desc
     */
    getDescById (id) {
        // 字段不存在返回‘’
        if (id === undefined || id === null) {
            return ''
        }
        for (let i in this) {
            let e = this[i];
            if (e && e.id === id) {
                return e.desc
            }
        }

        return ''
    }

    toProdChannelArr () {
        let arr = []
        for (let i in this) {
            arr.push({ "productCode": this[i].id, "payChannelCode": this[i].name, "productDesc": this[i].desc })
        }
        return arr
    }
}
